import React from 'react';
import { Image } from 'antd';
import { ArrowRightIcon, MessageQuestionIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch } from 'store';

import { setQuestionId, setTestFeedbackModal } from 'modules/global';
import { IOption, ISubQuestion } from 'modules/national-certificate';
import { useSelectedOption } from 'modules/national-certificate-test';

interface IProps {
  question?: ISubQuestion;
  index: number;
  length?: number;
  selectedOptionId?: number | null;
  allOptions: IOption[];
}

const Questions: React.FC<IProps> = ({ question, index, length, selectedOptionId, allOptions }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const { letter } = useSelectedOption({
    selectedOptionId,
    checked: question?.checked,
    allOptions
  });

  const onOpenFeedbackModal = () => {
    dispatch(setQuestionId(question?.question_id as number));
    dispatch(setTestFeedbackModal(true));
  };

  return (
    <div className="rounded-xl bg-gray-50 p-3">
      <div className="flex items-center justify-between">
        <div className="text-xs text-gray-400">
          {t('savol')}: {index + 1}/{length}
        </div>
        <div onClick={onOpenFeedbackModal} className="flex cursor-pointer items-center gap-2 text-orange-400">
          <MessageQuestionIcon />
        </div>
      </div>
      <div className="mt-3 flex items-end justify-between">
        <div className="whitespace-pre-line text-sm">{question?.question_name}</div>
        {question?.image && (
          <div className="mt-2 flex justify-center">
            <Image src={question?.image} alt={question?.name || 'Test option'} loading="lazy" title="Test image" />
          </div>
        )}
        {letter && (
          <div className="flex items-center gap-2 rounded-sm bg-white px-2.5 py-1 text-sm font-semibold text-green-500">
            <ArrowRightIcon />
            {letter}
          </div>
        )}
      </div>
    </div>
  );
};

export default Questions;
